import {
    Box,
    Card,
    CardMedia,
    Chip,
    Grid,
    Divider,
    Stack,
    Container
} from '@mui/material';

import { useGetBannerByIdQuery } from 'src/reduxServer/services/banner';

import { baseUrl } from 'src/utils/apis';
import Loader from 'src/components/Loader';
import { useParams } from 'react-router-dom';
import NoDataFound from 'src/components/NoDataFound';
import { useTranslation } from "react-i18next";
import PageTypography from 'src/components/PageTypography/PageTypography';


const AdDetailsPage = () => {
    const { t } = useTranslation();

    const id = useParams();
    

    const { data: bannerData, isLoading } = useGetBannerByIdQuery(parseInt(id.id));
    
    const bannerDetails = bannerData?.data;

    const ImgPAth = baseUrl + "core";


    const formatDate = (date: string) =>
        new Date(date).toLocaleDateString();
    if (isLoading) {
        return <Loader />;
    }
    if(bannerDetails.length === 0){
        return <NoDataFound/>
    }

    return (
        <Container maxWidth="xl" sx={{ marginTop: "100px" }}>
            <Card sx={{ borderRadius: 3, p: 2 }}>
                <Grid container spacing={3}>
                    {/* Image */}
                    <Grid item xs={12} md={6}>
                        <CardMedia
                            component="img"
                            image={bannerDetails?.image_url}
                            alt={bannerDetails?.title}
                            sx={{
                                borderRadius: 2,
                                height: 400,
                                objectFit: 'cover'
                            }}
                        />
                    </Grid>

                    {/* Details */}
                    <Grid item xs={12} md={6}>
                        <PageTypography variant="h5" fontWeight={700}>
                            {t("Ad Details")}
                        </PageTypography>

                        <PageTypography variant="h4" fontWeight={800} mt={1}>
                            {bannerDetails?.title}
                        </PageTypography>

                        {/* Status Chips */}
                        <Stack direction="row" spacing={1} mt={1}>
                            <Chip
                                label={bannerDetails?.is_active ? t("Active") : t("Inactive")}
                                 color={bannerDetails?.is_active === true ? 'success' : 'default'}
                                 sx={{marginLeft:"10px"}}
                            />
                            <Chip
                                label={`${t("Priority")}: ${
                                bannerDetails?.priority === 0 ? t("Normal") : bannerDetails?.priority
                                       }`}

                                variant="outlined"
                            />
                        </Stack>

                        <Divider sx={{ my: 2 }} />

                        {/* Info Rows */}
                        <Grid container spacing={2}>

                            <Grid item xs={6}>
                                <PageTypography color="text.secondary">{t("Click Count")}</PageTypography>
                                <PageTypography fontWeight={600}>{bannerDetails?.click_count}</PageTypography>
                            </Grid>

                            <Grid item xs={12}>
                                <PageTypography color="text.secondary">{t("Link")}</PageTypography>
                                <PageTypography
                                    component="a"
                                    href={bannerDetails?.link}
                                    target="_blank"
                                    sx={{ color: 'primary.main', fontWeight: 600 }}
                                >
                                    {bannerDetails?.link}
                                </PageTypography>
                            </Grid>

                            <Grid item xs={6}>
                                <PageTypography color="text.secondary">{t("Start Date")}</PageTypography>
                                <PageTypography fontWeight={600}>
                                    {formatDate(bannerDetails?.start_date)}
                                </PageTypography>
                            </Grid>

                            <Grid item xs={6}>
                                <PageTypography color="text.secondary">{t("End Date")}</PageTypography>
                                <PageTypography fontWeight={600}>
                                    {formatDate(bannerDetails?.end_date)}
                                </PageTypography>
                            </Grid>

                            <Grid item xs={6}>
                                <PageTypography color="text.secondary">{t("Created At")}</PageTypography>
                                <PageTypography fontWeight={600}>
                                    {formatDate(bannerDetails?.created_at)}
                                </PageTypography>
                            </Grid>

                            <Grid item xs={6}>
                                <PageTypography color="text.secondary">{t("Updated At")}</PageTypography>
                                <PageTypography fontWeight={600}>
                                    {formatDate(bannerDetails?.updated_at)}
                                </PageTypography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 3 }} />



                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
};

export default AdDetailsPage;
